module.exports = __webpack_public_path__ + "static/media/skeleton1.a3a58daf.gif";